exports = module.exports = require("../../../../../../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.common-routes-dialog .common-routes-header th {\n  background-color: #f5f7fa !important;\n}\n.common-routes-dialog tbody .common-routes-cell {\n  padding: 8px 0;\n}\n.common-routes-dialog .table-checkbox {\n  margin-left: 16px;\n}\n.common-routes-dialog .pagination-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n      -ms-flex-direction: row-reverse;\n          flex-direction: row-reverse;\n  padding-top: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?{"sourceMap":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6dcfdb6e","scoped":false,"hasInlineConfig":false}!./node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/views/personal/deliver/components/handlingWrapper/components/commonRoutesDialog/index.vue
// module id = eIsC
// module chunks = 1